export const blockIconsActivitiesScienceNew = (
	<span className='material-symbols-outlined'>science</span>
);
